import { ZodTypeAny } from 'zod'
import { env } from '@/env.ts'

export const validateSchemaInNonProdEnv = (
  schema: ZodTypeAny,
  obj: unknown
) => {
  if (!env.PROD) {
    const validation = schema.safeParse(obj)
    if (validation.error) console.error(validation.error)
    else return validation.data
  }
}

export const validateSchema = (schema: ZodTypeAny, obj: unknown) =>
  validateSchemaInNonProdEnv(schema, obj)

export const validateSchemaAsync = async <T>(
  schema: ZodTypeAny,
  promise: Promise<T>
) => {
  const resp = await promise
  validateSchemaInNonProdEnv(schema, resp)
  return resp
}
